export async function getConfigInfo() {
  //@ts-ignore
  const containerRef = window.containerRef;
  const canvasIframe = containerRef.current.contentWindow;
  return await canvasIframe.GatherInfo();
}
